import http from "../http"
import { User } from "../../models/user"
import HelperService from "../helper"
import { Pagination, QueryParams } from "../../models/misc"

class AdminUserService {
  private readonly baseUrl = "/admin"

  async readUsers(filters?: QueryParams) {
    const queryString = HelperService.buildSearchQueryString(filters)
    const { data } = await http.get<Pagination<User>>(`${this.baseUrl}/users${queryString}`)
    return data
  }

  async adminUpdateUser(userId: string, dto: Partial<User>) {
    const { data } = await http.put<User>(`${this.baseUrl}/user/${userId}`, dto)
    return data
  }
}

export default new AdminUserService()
